/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsLocaleModule
 */
export interface MelcoModelsLocaleModule {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleModule
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsLocaleModule
     */
    name?: string | null;
}

export function MelcoModelsLocaleModuleFromJSON(json: any): MelcoModelsLocaleModule {
    return MelcoModelsLocaleModuleFromJSONTyped(json, false);
}

export function MelcoModelsLocaleModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsLocaleModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function MelcoModelsLocaleModuleToJSON(value?: MelcoModelsLocaleModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
    };
}


